const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;

export default {
	data()
	{
		return {
			affixTopOffset: 60,
			// affixTop: 0,
			affixStyle: { top: 0 },
			isAffixFixed: false,
			affixYPercent: 0,
			affixSlideIndex: 0,
			isAffixAtBottom: false,
			isAffixTransitioning: false,
			affixSetSide: 'left',
		}
	},

	watch:
	{
		isAffixFixed(newVal)
		{
			if (this.isEditingPage)	return;
			if (newVal)
			{
				// consola.debug('dettaching affix...')
				if (this.affixSetSide)
				{
					const rect = this.$refs.affix.getBoundingClientRect();
					this.affixStyle[this.affixSetSide] = rect[this.affixSetSide] + 'px';
					// consola.debug(`affix [${this.affixSetSide}]: `, rect[this.affixSetSide])
				}
				this.$refs.affix.parentNode.removeChild( this.$refs.affix );
				document.body.appendChild( this.$refs.affix )
			}
			else
			{
				// consola.debug('re-attaching affix...')
				if (this.affixSetSide)
				{
					delete this.affixStyle[this.affixSetSide];
				}
				if (this.$refs.affix.parentNode)
					this.$refs.affix.parentNode.removeChild( this.$refs.affix );
				this.$refs.affixRails.appendChild( this.$refs.affix )
			}
		},
	},

	beforeDestroy()
	{
		consola.debug('affix before destroy...')
		if (this.isAffixFixed)
		{
			if (this.affixSetSide)
			{
				delete this.affixStyle[this.affixSetSide];
			}
			if (this.$refs.affix.parentNode)
				this.$refs.affix.parentNode.removeChild( this.$refs.affix );
			this.$refs.affixRails.appendChild( this.$refs.affix )
		}
	},

	methods:
	{

		calcAffixPos()
		{
			// consola.debug('calcAffixPos');
			// debugger

			if (this.isEditingPage)	return;

			if (this.isAffixTransitioning)	return;
			if (!this.$refs.affixRails || !this.$refs.affix || this.isMobile)
				return;
			// let railsBox = JSON.parse(JSON.stringify( this.$refs.affixRails.getBoundingClientRect() ));
			// let scrollingBox = JSON.parse(JSON.stringify( this.$refs.affix.getBoundingClientRect() ));
			let railsBox = ( this.$refs.affixRails.getBoundingClientRect() );
			let scrollingBox = ( this.$refs.affix.getBoundingClientRect() );

			let topOffset = 0;
			let menuEl = document.querySelector('.Menu');
			if (menuEl)
			{
				let box = menuEl.getBoundingClientRect();
				topOffset = box.bottom;
			}

			// let topOffset = this.affixTopOffset;
			// let topOffset = 0;

			this.affixYPercent = (scrollingBox.top - railsBox.top) / (railsBox.height - scrollingBox.height);
			let percent = Math.max(0, Math.min(this.affixYPercent, 1) );

			// this.isAffixFixed = (railsBox.top < topOffset) && (railsBox.bottom > window.innerHeight) && !this.isAffixAtBottom;
			const isRailAboveTop = railsBox.top < topOffset;
			const isRailBelowBottom = railsBox.bottom >  topOffset + scrollingBox.height;
			this.isAffixFixed = isRailAboveTop && isRailBelowBottom;// && !this.isAffixAtBottom;
			if (this.isAffixAtBottom)	return;

			this.affixTop = this.isAffixFixed ? topOffset : 0;
			// let style = {
			// 	top: `${this.isAffixFixed ? topOffset : 0}px`,
			// 	// opacity: 1 - (-railsBox.top / railsBox.height)
			// };
			this.affixStyle.top = `${this.isAffixFixed ? topOffset : 0}px`
			this.affixStyle.bottom = '';

			if (this.isAffixFixed)
				this.affixStyle.position = 'absolute';

			if ( railsBox.bottom <  topOffset + scrollingBox.height )
			{
				this.affixStyle.top = 'unset';
				this.affixStyle.bottom = 0;
				this.affixStyle.position = 'absolute';
			}
			else
			{
				this.affixStyle.bottom = '';
			}

			// if (!this.isAffixAtBottom)
			// 	this.affixStyle = style;
		},
	}


}
